module.exports = __webpack_public_path__ + "media/svg-new/support-blue-c1d2983d.svg";